function compareText(left, right) {
  return String(left || '').localeCompare(String(right || ''), 'ru', {
    sensitivity: 'base',
  });
}

function compareDate(left, right) {
  const leftTime = left ? new Date(left).getTime() : 0;
  const rightTime = right ? new Date(right).getTime() : 0;
  return leftTime - rightTime;
}

const SORTERS = {
  employee_name: (a, b) => compareText(a?.employee_name, b?.employee_name),
  group_name: (a, b) => compareText(a?.group_name || 'Основная', b?.group_name || 'Основная'),
  license_type: (a, b) => compareText(a?.license_type, b?.license_type),
  role: (a, b) => compareText(a?.role, b?.role),
  assigned_at: (a, b) => compareDate(a?.assigned_at, b?.assigned_at),
};

export function filterAndSortAssignments(
  assignments,
  {
    search = '',
    licenseType = 'all',
    sortBy = 'employee_name',
    sortDir = 'asc',
  } = {},
) {
  const source = Array.isArray(assignments) ? assignments : [];
  const query = search.trim().toLocaleLowerCase('ru-RU');

  const filtered = source.filter((item) => {
    if (licenseType !== 'all' && item?.license_type !== licenseType) {
      return false;
    }

    if (!query) return true;

    return String(item?.employee_name || '')
      .toLocaleLowerCase('ru-RU')
      .includes(query);
  });

  const compare = SORTERS[sortBy] || SORTERS.employee_name;

  return filtered.sort((a, b) => {
    const result = compare(a, b);
    return sortDir === 'desc' ? -result : result;
  });
}
